
import React from "react";

const About = () => {
  return (
    <div className="about-us container py-5">
      <h2 className="text-center text-danger fw-bold">About Prakash Institute</h2>
      <div className="row mt-4">
        <div className="col-md-6 col-12">
          <img
            src="https://via.placeholder.com/400x300"
            alt="About Us"
            className="img-fluid"
          />
        </div>
        <div className="col-md-6 col-12">
          <p>
            Prakash Institute of Education is a renowned coaching center that provides top-notch
            coaching for IIT-JEE, NEET, and State Board Exams. Our expert faculty, structured
            curriculum, and personalized mentoring system ensure the success of every student.
          </p>
          <ul>
            <li>Experienced Faculty</li>
            <li>Proven Results</li>
            <li>Comprehensive Study Material</li>
            <li>Regular Mock Tests</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default About;
